import React, { Fragment } from "react";
import moment from "moment";
import { Grid } from "@material-ui/core";
import _ from "lodash";

import { DateItem,
  TextItem,
  CurrencyItem,
  PercentItem,
  PercentNoDecimalItem,
  DscrItem,
  ItemLinks, NoItems, getMinValue, getExtensionTriggers, getListItemLink, makePercent, makeDSCR } from "../util";
import { ItemList } from "../styles";

const getPercentField = (selectedLoan, field) => {
  const value = _.get(selectedLoan, field);

  return value ? (value * 100) : "";
};

export const PaidOffLoanComponent = ({ loans, Link, fundId, dealId, handleSelect, selectedLoan }) => {
  if (!loans || loans.length === 0) {
    return <NoItems Message={"There are no paid off loans for this deal."} />;
  }

  if (selectedLoan === null) {
    return null;
  }

  const ltvStabilized = _.get(selectedLoan, "covenants.ltvStabilized");
  const dscrStabilized = _.get(selectedLoan, "covenants.dscrStabilized");
  const debtYieldStabilized = _.get(selectedLoan, "covenants.debtYieldStabilized");

  return (<>

    <Grid container spacing={8} alignItems="flex-start" justify="flex-start" direction="row">
      <Grid item lg={3} md={4} sm={4} xs={4}>
        <ItemList id="paidOffLoansList">
          {loans
            .sort((a, b) => moment.utc(b.maturityDate).unix() - moment.utc(a.maturityDate).unix())
            .map(loan => getListItemLink(loan, selectedLoan, handleSelect))}
        </ItemList>
      </Grid>
      <Grid item lg={8} md={8} sm={8} xs={8}>
        <Grid container spacing={8} alignItems="flex-start" justify="flex-start" direction="row">
          <Grid item md={6} sm={12} xs={12} id="paidOffLoansInfoLeft">

            <DateItem
              value={selectedLoan.paidOffDate}
              label="Paid Off Date"
            />
            <DateItem
              value={selectedLoan.maturityDate}
              label="Maturity"
            />
            <TextItem
              value={_.get(selectedLoan, "rateTypeRef.name")}
              label="Rate Type"
            />
            <TextItem
              value={_.get(selectedLoan, "index.name")}
              label="Index"
            />
            <PercentItem
              value={getPercentField(selectedLoan, "loanSpread")}
              label="Spread"
            />
            <PercentItem
              value={getPercentField(selectedLoan, "indexFloor")}
              label="Floor"
            />
            <TextItem
              value={_.get(selectedLoan, "loanRecourse.recourseType.name")}
              label="Recourse"
            />
          </Grid>

          <Grid item md={6} sm={12} xs={12} id="paidOffLoansInfoRight">

            <PercentNoDecimalItem
              value={getPercentField(selectedLoan, "covenants.ltvStabilized")}
              label="Maximum LTV"
            />
            <DscrItem
              value={!selectedLoan.covenants || selectedLoan.covenants.dscrStabilized}
              label="Minimum DSCR"
            />
            <PercentItem
              value={getPercentField(selectedLoan, "covenants.debtYieldStabilized")}
              label="Minimum Debt Yield"
            />
            <CurrencyItem
              value={getMinValue(selectedLoan.guarantors, "netWorth")}
              label="Minimum Net Worth"
            />
            <CurrencyItem
              value={getMinValue(selectedLoan.guarantors, "liquidity")}
              label="Minimum Liquidity"
            />
            <CurrencyItem
              value={_.get(selectedLoan, "covenants.minCashDeposit")}
              label="Minimum Cash Deposits"
            />
            <TextItem
              value={getExtensionTriggers(makePercent(ltvStabilized), makeDSCR(dscrStabilized), makePercent(debtYieldStabilized))}
              label="Extension Triggers"
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>

    <ItemLinks
      itemName={`Loan${selectedLoan.id}`}
      DetailsLink={`/portfolio/funds/${fundId}/deals/${dealId}/loans/${selectedLoan.id}/loanDetailsPage/0`}
      shouldShowCashflowsLink
      CashflowsLink={`/portfolio/funds/${fundId}/deals/${dealId}/cashflowsPage?loanId=${selectedLoan.id}`}
      Link={Link}
    />

  </>);
};
